module.exports = __webpack_public_path__ + "img/6s.32d395c3.png";